import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { computed, observable } from 'mobx'

export type PlatformConnection = QuickBooksAccount | XeroAccount | OtherAccount

export type PlatformConnectionTypeProps =
  | QuickBooksAccountTypeProps
  | XeroAccountTypeProps
  | OtherAccountTypeProps

/**
 * Props for {@link QuickBooksAccount}.
 */
export interface QuickBooksAccountTypeProps {
  type: 'QuickBooks'
  quickBooks: ModelProps<QuickBooksAccount>
}

export class QuickBooksAccount extends Model<QuickBooksAccount> {
  readonly url = 'https://accounts.intuit.com/app/sign-in'

  @observable
  accessor connectionId = Id.none

  @observable
  accessor realmId = Id.none

  @observable
  accessor companyName = ''

  /**
   * The display name.
   */
  @computed
  get displayName() {
    return this.companyName
  }
}

/**
 * Props for {@link XeroAccount}.
 */
export interface XeroAccountTypeProps {
  type: 'Xero'
  xero: ModelProps<XeroAccount>
}

export class XeroAccount extends Model<XeroAccount> {
  readonly url = 'https://accounts.intuit.com/app/sign-in'

  @observable
  accessor connectionId = Id.none

  @observable
  accessor tenantId = Id.none

  @observable
  accessor tenantName = ''

  /**
   * The display name.
   */
  @computed
  get displayName() {
    return this.tenantName
  }
}

/**
 * Props for {@link OtherAccount}.
 */
export interface OtherAccountTypeProps {
  type: 'Other'
  other: ModelProps<OtherAccount>
}

export class OtherAccount extends Model<OtherAccount> {
  @observable
  accessor info = ''

  /**
   * The display name.
   */
  @computed
  get displayName() {
    return this.info
  }
}
